import {get} from 'lodash';

import StudentApi from '../helper/StudentApi'
import {
    updateReadList,
    updateWatchList,
    bookGenresUpdate,
    challengeLevelUpdate,
    updatePersonalChoiceList,
    challengeRulesUpdate,
    logonEnabledUpdate,
} from './user';

const STUDENT_DETAILS = 'student/STUDENT_DETAILS';
const READING_PLAN = 'student/READING_PLAN';
const SURVEY_STATUS_UPDATE = 'student/SURVEY_STATUS_UPDATE';

const initialState = {
  readingPlan: [],
  readingRecord: {},
  studentDetails: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case STUDENT_DETAILS:
      return {
        ...state,
        studentDetails: get(action, 'payload', {}),
        readingRecord: get(action, 'payload.srr', {}),
      };
    case READING_PLAN:
      return {
        ...state,
        readingPlan: action.payload,
      };
    case SURVEY_STATUS_UPDATE:
      return {
        ...state,
        studentDetails: {
           ...state.studentDetails,
           surveyTaken: action.payload,
        }
      };
    default:
      return state;
  }
}

export const studentDetailsUpdate = (studentDetails) => ({
  type: STUDENT_DETAILS,
  payload: studentDetails,
})

export const readingPlanUpdate = (readingPlan) => ({
  type: READING_PLAN,
  payload: readingPlan,
})

export const updateSurveyStatus = (status) => {
    return dispatch =>
        dispatch({
            type: SURVEY_STATUS_UPDATE,
            payload: status,
        });
}

export const fetchStudentDetails = () => (dispatch, getState) => {
    // launch student details and reading plan requests in parallel
      StudentApi.getStudentDetails()
      .then(studentDetails => {
          dispatch(studentDetailsUpdate(studentDetails))
          const readingLog = get(studentDetails, 'srr.books', []);
          dispatch(updateReadList(readingLog))
          dispatch(updatePersonalChoiceList(readingLog))
          }).catch(err => console.log(err));

      StudentApi.getReadingPlan()
      .then(readingPlan => {
          dispatch(readingPlanUpdate(readingPlan.books))
          dispatch(updateWatchList(readingPlan.books))
        }).catch(err => console.log(err));
}

export const fetchSearchOptions = () => (dispatch, getState) => {
    // launch discover options
    StudentApi.getBookGenres()
        .then( result => {
            dispatch(bookGenresUpdate(result.genres))
        })
    StudentApi.getChallengeLevel()
        .then( result => {
            const rules = result.rules
            dispatch(challengeRulesUpdate(rules));
            let levels = rules
                // exclude internal rules (e.g. the 3-9 uber challenge)
                .filter(r => r.publicFacing)
                .map(r => r.challengeName)
                .sort();
            levels.unshift(levels.pop())  // move 'k-2' to the beginning of the array ...
            dispatch(challengeLevelUpdate(levels))
        })
    StudentApi.getLogonEnabled()
            .then( result => {
                dispatch(logonEnabledUpdate(result.logonEnabled))
            })
}
